(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    initMobileNav();
    initProductAccordions();
    initFaqAccordion();
    initQuantitySelectors();
    initProductGallery();
    initLightbox();
    initVariantPills();
    initScrollReveal();
    initStickyHeader();
    initSearchOverlay();
    initCartQuantityButtons();
    initCartAutoUpdate();
    initHeroSlideshow();
    initAddToCart();
    initQuickAdd();
    initCartDrawer();
    initStickyAtc();
  }

  /* ── Utilities ── */
  function lockBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isVariantAvailable(variant, form) {
    if (!variant) return false;
    if (variant.available === true) return true;
    if (variant.available === false) return false;
    form = form || document.querySelector('[data-product-form]');
    if (form && form.dataset.variantInStock === 'true') return true;
    if (form && form.dataset.variantInStock === 'false') return false;
    return true;
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute('hidden', '');
    } else {
      el.removeAttribute('hidden');
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('.site-header__cart').forEach(function (link) {
      var badge = link.querySelector('[data-cart-count], .cart-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        badge.setAttribute('aria-hidden', 'true');
        badge.setAttribute('data-cart-count', '');
        link.appendChild(badge);
      }
      badge.textContent = count;
      badge.hidden = count === 0;
      badge.style.display = count === 0 ? 'none' : '';
      badge.classList.toggle('is-hidden', count === 0);
      badge.classList.add('is-bump');
      setTimeout(function () { badge.classList.remove('is-bump'); }, 400);
      link.setAttribute('aria-label', 'Cart (' + count + ' items)');
    });
  }

  function showToast(message, type) {
    var region = document.querySelector('[data-toast-region]');
    if (!region) return;

    var toast = document.createElement('div');
    toast.className = 'toast toast--' + (type || 'success');
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="toast__message">' + message + '</span>' +
      '<button type="button" class="toast__close" aria-label="Dismiss">&times;</button>';

    region.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });

    function dismiss() {
      toast.classList.remove('is-visible');
      toast.addEventListener('transitionend', function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, { once: true });
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }

    toast.querySelector('.toast__close').addEventListener('click', dismiss);
    setTimeout(dismiss, 4500);
  }

  function trapFocus(container, onEscape) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key === 'Escape' && onEscape) {
        e.preventDefault();
        onEscape();
        return;
      }
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('keydown', handler);
    return function () { document.removeEventListener('keydown', handler); };
  }

  /* ── Accordion panel animation ── */
  function toggleAccordionPanel(btn, panel, isOpen) {
    if (prefersReducedMotion) {
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
      return;
    }

    if (isOpen) {
      panel.style.height = panel.scrollHeight + 'px';
      panel.removeAttribute('hidden');
      requestAnimationFrame(function () {
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });
      panel.addEventListener('transitionend', function onClose(e) {
        if (e.propertyName !== 'height') return;
        panel.setAttribute('hidden', '');
        panel.style.height = '';
        panel.style.opacity = '';
        panel.removeEventListener('transitionend', onClose);
      }, { once: true });
      btn.setAttribute('aria-expanded', 'false');
    } else {
      panel.removeAttribute('hidden');
      panel.style.height = '0px';
      panel.style.opacity = '0';
      requestAnimationFrame(function () {
        panel.style.height = panel.scrollHeight + 'px';
        panel.style.opacity = '1';
      });
      panel.addEventListener('transitionend', function onOpen(e) {
        if (e.propertyName !== 'height') return;
        panel.style.height = '';
        panel.style.opacity = '';
        panel.removeEventListener('transitionend', onOpen);
      }, { once: true });
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  /* ── Mobile nav ── */
  function initMobileNav() {
    var toggle = document.querySelector('.site-header__menu-toggle');
    var nav = document.getElementById('mobile-nav');
    var overlay = document.querySelector('.mobile-nav-overlay');
    var close = document.querySelector('.mobile-nav__close');
    if (!toggle || !nav) return;

    var releaseFocus = null;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-open');
      lockBodyScroll();
      if (close) close.focus();
      releaseFocus = trapFocus(nav, shut);
    }

    function shut() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-open');
      unlockBodyScroll();
      if (releaseFocus) { releaseFocus(); releaseFocus = null; }
      toggle.focus();
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (overlay) overlay.addEventListener('click', shut);

    nav.querySelectorAll('.mobile-nav__list a').forEach(function (link) {
      link.addEventListener('click', shut);
    });
  }

  /* ── Search overlay ── */
  function initSearchOverlay() {
    var btn = document.querySelector('[data-search-toggle]');
    var overlay = document.querySelector('.search-overlay');
    var closeBtn = document.querySelector('[data-search-close]');
    var input = overlay ? overlay.querySelector('.search-overlay__input') : null;
    if (!btn || !overlay) return;

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      if (input) {
        setTimeout(function () { input.focus(); }, 120);
      }
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (input) input.value = '';
      btn.focus();
    }

    btn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        close();
      }
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        overlay.classList.contains('is-open') ? close() : open();
      }
    });

    document.addEventListener('click', function (e) {
      if (overlay.classList.contains('is-open') &&
          !overlay.contains(e.target) &&
          !btn.contains(e.target)) {
        close();
      }
    });
  }

  /* ── FAQ accordion ── */
  function initFaqAccordion() {
    document.querySelectorAll('.faq-accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-accordion__item');
        var panel = item.querySelector('.faq-accordion__panel');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        item.closest('.faq-accordion').querySelectorAll('.faq-accordion__item').forEach(function (other) {
          if (other !== item) {
            var otherBtn = other.querySelector('.faq-accordion__trigger');
            var otherPanel = other.querySelector('.faq-accordion__panel');
            if (otherBtn.getAttribute('aria-expanded') === 'true') {
              toggleAccordionPanel(otherBtn, otherPanel, true);
            }
          }
        });

        toggleAccordionPanel(btn, panel, isOpen);
      });
    });
  }

  /* ── Product accordions ── */
  function initProductAccordions() {
    document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.accordion__item');
        var panel = item.querySelector('.accordion__panel');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        toggleAccordionPanel(btn, panel, isOpen);
      });
    });
  }

  /* ── Quantity selectors ── */
  function initQuantitySelectors() {
    document.querySelectorAll('.qty-selector').forEach(function (sel) {
      if (sel.closest('.cart-item__qty')) return;
      var input = sel.querySelector('.qty-selector__input');
      if (!input) return;
      sel.querySelectorAll('.qty-selector__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          if (btn.dataset.action === 'increment') val++;
          if (btn.dataset.action === 'decrement' && val > min) val--;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── Cart quantity buttons ── */
  function initCartQuantityButtons() {
    document.querySelectorAll('.cart-item__qty .qty-selector__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sel = btn.closest('.qty-selector');
        var input = sel.querySelector('.qty-selector__input');
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'increment') val++;
        if (btn.dataset.action === 'decrement' && val > 0) val--;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ── Cart auto-update ── */
  function initCartAutoUpdate() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    var debounceTimer = null;

    form.querySelectorAll('.cart-item__qty .qty-selector__input').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          var line = input.dataset.line;
          var quantity = parseInt(input.value, 10) || 0;

          form.classList.add('is-updating');

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Cart update failed');
              return res.json();
            })
            .then(function () {
              window.location.reload();
            })
            .catch(function () {
              form.classList.remove('is-updating');
              showToast('Could not update cart', 'error');
            });
        }, 500);
      });
    });
  }

  /* ── Variant resolution (size/options → variant id) ── */
  function getProductVariantContext(form) {
    form = form || document.querySelector('[data-product-form]');
    if (!form) return null;

    var variantScript = document.querySelector('[data-product-variants]');
    var variantIdInput = form.querySelector('[data-variant-id]');
    if (!variantScript || !variantIdInput) return null;

    var variants;
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      return null;
    }

    var optionGroups = form.querySelectorAll('.variant-selector');

    function getSelectedOptions() {
      var options = [];
      optionGroups.forEach(function (group, index) {
        var checked = group.querySelector('input[type="radio"]:checked');
        options[index] = checked ? checked.value.trim() : null;
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    return {
      form: form,
      variants: variants,
      variantIdInput: variantIdInput,
      optionGroups: optionGroups,
      getSelectedOptions: getSelectedOptions,
      findVariant: findVariant
    };
  }

  function resolveSelectedVariant(form) {
    var ctx = getProductVariantContext(form);
    if (!ctx) return null;
    if (!ctx.optionGroups.length) {
      return ctx.variants.find(function (v) {
        return v.id === parseInt(ctx.variantIdInput.value, 10);
      }) || null;
    }
    return ctx.findVariant(ctx.getSelectedOptions()) || null;
  }

  function syncVariantIdInput(form) {
    var ctx = getProductVariantContext(form);
    if (!ctx || !ctx.optionGroups.length) return null;

    var variant = ctx.findVariant(ctx.getSelectedOptions());
    if (variant) {
      ctx.variantIdInput.value = variant.id;
    }
    return variant;
  }

  function buildAddToCartPayload(form) {
    var variant = syncVariantIdInput(form);
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!variant) {
      return null;
    }

    var payload = new FormData();
    payload.append('id', variant.id);
    payload.append('quantity', quantity);
    return payload;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function handleCartUpdate(cart, options) {
    options = options || {};
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
    if (options.openDrawer !== false) {
      openCartDrawer();
    }
    if (options.message) {
      showToast(options.message, 'success');
    }
  }

  /* ── Cart drawer ── */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });

    drawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        var line = parseInt(removeBtn.dataset.cartRemove, 10);
        removeCartLine(line);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = '/checkout';
      });
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function removeCartLine(line) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Remove failed');
        return res.json();
      })
      .then(function (cart) {
        handleCartUpdate(cart, { openDrawer: true, message: 'Item removed' });
      })
      .catch(function () {
        showToast('Could not update cart', 'error');
      });
  }

  function renderCartDrawer(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var body = drawer.querySelector('[data-cart-drawer-body]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
    var threshold = (window.theme && window.theme.freeShippingThreshold) || 4900;

    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cart-drawer__empty" data-cart-drawer-empty>' +
          '<p>Your cart is empty.</p>' +
          '<a href="' + (window.theme.routes ? window.theme.routes.allProducts : '/collections/all') + '" class="btn btn--primary" data-cart-drawer-close>Start shopping</a>' +
        '</div>';
      if (footer) footer.classList.add('is-hidden');
      return;
    }

    var shippingHtml = '';
    if (cart.total_price >= threshold) {
      shippingHtml = '<p class="cart-drawer__shipping-msg cart-drawer__shipping-msg--success">You\'ve unlocked free shipping!</p>';
    } else {
      var remaining = threshold - cart.total_price;
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      shippingHtml =
        '<p class="cart-drawer__shipping-msg">Add <strong>' + formatMoney(remaining) + '</strong> more for free shipping</p>' +
        '<div class="cart-drawer__shipping-track"><div class="cart-drawer__shipping-fill" style="width:' + pct + '%"></div></div>';
    }

    var itemsHtml = '<div class="cart-drawer__shipping" data-cart-drawer-shipping>' + shippingHtml + '</div><ul class="cart-drawer__items" data-cart-drawer-items role="list">';
    cart.items.forEach(function (item, index) {
      var variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      var imageSrc = item.image ? item.image.replace(/(\._.*?)\./, '.') : '';
      itemsHtml +=
        '<li class="cart-drawer__item" data-cart-line="' + (index + 1) + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-image" tabindex="-1" aria-hidden="true">' +
            (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">' : '') +
          '</a>' +
          '<div class="cart-drawer__item-details">' +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
            variantLine +
            '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
          '<button type="button" class="cart-drawer__item-remove" data-cart-remove="' + (index + 1) + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">&times;</button>' +
        '</li>';
    });
    itemsHtml += '</ul>';

    body.innerHTML = itemsHtml;
    if (footer) footer.classList.remove('is-hidden');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    body.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
  }

  /* ── Sticky mobile add to cart ── */
  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainAtc = document.querySelector('[data-product-atc]');
    var form = document.querySelector('[data-product-form]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    if (!sticky || !mainAtc || !form) return;

    sticky.removeAttribute('hidden');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '0px' });
      observer.observe(mainAtc);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        form.requestSubmit(mainAtc);
        window.scrollTo({ top: form.offsetTop - 80, behavior: 'smooth' });
      });
    }
  }

  function updateStickyPrice(cents) {
    var el = document.querySelector('[data-sticky-price]');
    if (el) el.textContent = formatMoney(cents);
  }

  function updateStickyAtcState(variant) {
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    if (!stickyBtn || !variant) return;
    var available = isVariantAvailable(variant);
    stickyBtn.disabled = !available;
    stickyBtn.textContent = available ? 'Add to cart' : 'Sold out';
  }
  function initAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-product-atc]');
      var atcText = form.querySelector('[data-atc-text]');
      if (!btn || btn.disabled) return;

      var formData = buildAddToCartPayload(form);
      if (!formData) {
        showToast('Please select an available option.', 'error');
        return;
      }

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          handleCartUpdate(cart, { message: 'Added to cart' });
          if (atcText) {
            atcText.textContent = 'Added!';
            setTimeout(function () {
              if (!btn.disabled) atcText.textContent = 'Add to cart';
            }, 2000);
          }
        })
        .catch(function () {
          showToast('Could not add to cart. Please try again.', 'error');
        })
        .finally(function () {
          btn.classList.remove('is-loading');
          var variant = resolveSelectedVariant(form);
          var available = variant ? isVariantAvailable(variant, form) : true;
          btn.disabled = variant ? !available : false;
        });
    });
  }

  /* ── Quick add (product cards) ── */
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;

        var originalText = btn.textContent;
        btn.classList.add('is-loading');
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function (item) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) {
              return r.json().then(function (cart) {
                return { item: item, cart: cart };
              });
            });
          })
          .then(function (data) {
            handleCartUpdate(data.cart, { message: data.item.title + ' added to cart' });
            btn.textContent = 'Added!';
            setTimeout(function () { btn.textContent = originalText; }, 2000);
          })
          .catch(function () {
            showToast('Could not add to cart', 'error');
          })
          .finally(function () {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          });
      });
    });
  }

  /* ── Product gallery carousel ── */
  function initProductGallery() {
    var carousel = document.querySelector('[data-gallery-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-gallery-slide]');
    var dots = document.querySelectorAll('[data-gallery-dot]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    var current = 0;
    var total = slides.length;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      slides[current].scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.galleryDot, 10)); });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(parseInt(thumb.dataset.galleryThumb, 10)); });
    });

    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    var scrollTick = false;
    carousel.addEventListener('scroll', function () {
      if (!scrollTick) {
        requestAnimationFrame(function () {
          var scrollLeft = carousel.scrollLeft;
          var slideWidth = carousel.offsetWidth;
          var newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== current && newIndex >= 0 && newIndex < total) {
            current = newIndex;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
            thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
          }
          scrollTick = false;
        });
        scrollTick = true;
      }
    }, { passive: true });
  }

  /* ── Lightbox ── */
  function initLightbox() {
    var lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-img]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var closeBtns = lightbox.querySelectorAll('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var images = [];
    var currentIdx = 0;

    document.querySelectorAll('[data-gallery-slide], .product-gallery__single').forEach(function (slide) {
      if (slide.dataset.full) images.push(slide.dataset.full);
    });

    function open(index) {
      currentIdx = index;
      show();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
    }

    function preloadAdjacent() {
      if (images.length < 2) return;
      [1, -1].forEach(function (offset) {
        var idx = (currentIdx + offset + images.length) % images.length;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'image';
        link.href = images[idx];
        document.head.appendChild(link);
      });
    }

    function show() {
      if (!images.length) return;
      img.style.opacity = '0';
      img.onload = function () { img.style.opacity = '1'; };
      img.src = images[currentIdx];
      if (counter) counter.textContent = (currentIdx + 1) + ' / ' + images.length;
      preloadAdjacent();
    }

    function prev() { currentIdx = (currentIdx - 1 + images.length) % images.length; show(); }
    function next() { currentIdx = (currentIdx + 1) % images.length; show(); }

    document.querySelectorAll('[data-gallery-slide], .product-gallery__single').forEach(function (slide, i) {
      slide.addEventListener('click', function () { open(i); });
    });

    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var lbTouchX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      lbTouchX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var diff = lbTouchX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });
  }

  /* ── Variant pill selector ── */
  function initVariantPills() {
    var ctx = getProductVariantContext();
    if (!ctx || !ctx.optionGroups.length) return;

    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var saleBadge = document.querySelector('[data-product-sale-badge]');
    var atcBtn = document.querySelector('[data-product-atc]');
    var atcText = document.querySelector('[data-atc-text]');
    var soldOutMsg = document.querySelector('[data-product-sold-out-msg]');

    function updateVariantUI(variant) {
      if (!variant) return;

      var available = isVariantAvailable(variant, ctx.form);
      ctx.variantIdInput.value = variant.id;
      ctx.form.dataset.variantInStock = available ? 'true' : 'false';

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      updateStickyPrice(variant.price);
      updateStickyAtcState(variant);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        setHidden(compareEl, !onSale);
      }
      if (saleBadge) setHidden(saleBadge, !onSale);

      if (atcBtn) atcBtn.disabled = !available;
      if (atcText) atcText.textContent = available ? 'Add to cart' : 'Sold out';
      if (soldOutMsg) setHidden(soldOutMsg, available);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function syncVariantIdOnly() {
      var variant = ctx.findVariant(ctx.getSelectedOptions());
      if (variant) {
        ctx.variantIdInput.value = variant.id;
      }
    }

    function onOptionChange() {
      var variant = ctx.findVariant(ctx.getSelectedOptions());
      if (variant) updateVariantUI(variant);
    }

    ctx.optionGroups.forEach(function (group) {
      group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', onOptionChange);
      });
      group.querySelectorAll('.variant-selector__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          requestAnimationFrame(onOptionChange);
        });
      });
    });

    /* Sync hidden variant id on load — do not override server availability UI */
    syncVariantIdOnly();
  }

  /* ── Scroll reveal animation ── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 60, 360) + 'ms';
      observer.observe(el);
    });
  }

  /* ── Sticky header shadow ── */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var scrolled = false;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var isScrolled = window.scrollY > 10;
          if (isScrolled !== scrolled) {
            scrolled = isScrolled;
            header.classList.toggle('is-scrolled', scrolled);
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Hero slideshow ── */
  function initHeroSlideshow() {
    var slideshow = document.querySelector('[data-hero-slideshow]');
    if (!slideshow) return;

    var slides = slideshow.querySelectorAll('.home-hero__slide');
    if (slides.length < 2) return;

    var current = 0;
    var hero = slideshow.closest('.home-hero');
    var duration = parseInt(hero ? hero.dataset.slideDuration : 5, 10) || 5;
    var intervalId = null;
    var paused = false;

    function advance() {
      if (paused || prefersReducedMotion) return;
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    function start() {
      if (prefersReducedMotion) return;
      stop();
      intervalId = setInterval(advance, duration * 1000);
    }

    function stop() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    hero.addEventListener('mouseenter', function () { paused = true; });
    hero.addEventListener('mouseleave', function () { paused = false; });
    hero.addEventListener('focusin', function () { paused = true; });
    hero.addEventListener('focusout', function () { paused = false; });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
